import momentTz from "moment-timezone";

export const debounce = (func, delay) => {
  let timeoutId;

  return function (...args) {
    clearTimeout(timeoutId);

    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};

export const formatDate = (dateString) => {
  if (!dateString) return null;

  const m = momentTz(dateString);
  if (!m.isValid()) return null;

  return m.tz(momentTz.tz.guess()).format("DD MMM YYYY, h:mm a");
};
export const getFileType = (url) => {
  console.log("url==", url);
  if (!url) return "unknown";
  try {
    const path = url.split("?")[0];
    const extension = path.split(".").pop().toLowerCase();
    const imageExtensions = ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"];
    if (extension === "pdf") return "pdf";
    if (imageExtensions.includes(extension)) return "image";
    return "unknown";
  } catch (err) {
    return "unknown";
  }
};
